import { render } from "./modalpayment.vue?vue&type=template&id=a3f4165e"
import script from "./modalpayment.vue?vue&type=script&lang=js"
export * from "./modalpayment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__